export default "__VITE_ASSET__2OXSe6Sc__";